export default "__VITE_ASSET__nvQ0hBtF__"